import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const textBlocksRoutes: Route[] = [
    {
        path: 'text-blocks',
        title: 'PRSS | Список текстовых блоков',
        loadComponent: () =>
            import('@pages/guids/text-blocks/text-blocks.component').then(
                (c) => c.TextBlocksComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_textblocks')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Текстовые блоки', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'text-blocks/:id',
        title: 'PRSS | Редактирование текстового блока',
        loadComponent: () =>
            import('@pages/guids/text-blocks/text-block-details/text-block-details.component').then(
                (c) => c.TextBlockDetailsComponent,
            ),
        // canActivate: [guardOrganizationWatch],
        canActivate: [authGuard],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Текстовые блоки', url: '/text-blocks/' },
            ],
            searchString: false,
        },
    },
];
